import { useFormState } from 'react-final-form';

import { PreviewJson, CodeEditor, Box } from '@cast/design-system';

import { FormModel } from './types';

import { RffCodeEditor, WhenMode } from '@cast/shared-rff-ui';

export const RequestTemplateRow = () => {
  const state = useFormState<FormModel>();
  const requestTemplate = state.values.requestTemplate;
  return (
    <WhenMode
      mode="view"
      fallback={
        <RffCodeEditor
          name="requestTemplate"
          rows={5}
          highlight="json"
          testId="alert-request-template"
        />
      }
    >
      {!!requestTemplate?.length && (
        <Box
          sx={{
            '& .Json-error': { pl: '32px' },
            overflow: 'hidden',
          }}
        >
          <PreviewJson
            data={requestTemplate}
            renderFallback={(data) => {
              return (
                <CodeEditor
                  value={data}
                  highlight="json"
                  disabled
                  sx={{ p: 16 }}
                  testId="request-template-preview-fallback"
                />
              );
            }}
          />
        </Box>
      )}
    </WhenMode>
  );
};
